<template>
    <div
        :class="{
            'flex flex-col md:flex-row-reverse md:items-center': isResponsive
        }"
        class="px-4 py-3 bg-grey-bg sm:px-6"
    >
        <div
            :class="{
                'mb-3': showRequired,
                'md:mb-0': isResponsive
            }"
            class="flex-grow text-right"
        >
            <slot />
        </div>

        <div
            v-if="showRequired"
            class="text-sm leading-tight text-grey-darker"
        >
            <slot name="required">
                <span class="text-red">•</span> Required
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isResponsive: {
                type: Boolean,
                default: true
            },
            showRequired: {
                type: Boolean,
                default: true
            }
        }
    }
</script>
